<script>
    import { createEventDispatcher } from "svelte";

    import { getArtworkURL } from "../utils.js";

    export let item;
    export let artSize = 40;
    export let minimal = false;

    const dispatch = createEventDispatcher();

    const music = MusicKit.getInstance();

    $: attrs = item.attributes;
    $: explicit = (attrs.contentRating == "explicit");
    $: durationInSeconds = attrs.durationInMillis / 1000;
    $: formattedDuration = MusicKit.formatMediaTime(durationInSeconds, ':');
    $: artworkUrl = attrs && getArtworkURL(item, artSize, artSize) || '/missing-artwork.svg';

    function handleDragStart(event) {
        console.log("item dragged", item);
        event.dataTransfer.clearData();
        event.dataTransfer.setData("application/json", JSON.stringify({ id: item.id, type: item.type }));
        // event.dataTransfer.setDragImage(img, img.width / 2, img.height / 2);
    }

    let root;
    function handleContextMenu({ pageX, pageY }) {
        dispatch("context-menu", { pageX, pageY, target: root });
    }    
</script>

<div class="root" on:click on:contextmenu|preventDefault={handleContextMenu}>
    {#if minimal}
        <div class="item minimal"
            draggable="true"
            on:dragstart={handleDragStart}
            bind:this={root}>
            <div class="track-number">{attrs.trackNumber}</div>
            <div class="desc">
                <div class="name-line" style="--template-columns: {explicit ? "auto min-content 1fr" : "auto 1fr"}">
                    <div class="name" title="{attrs.name}">{attrs.name}</div>
                    {#if explicit}
                        <div class="explicit" title="Explicit song">E</div>
                    {/if}
                </div>
                <div class="artist-album">
                    {attrs.artistName}
                </div>
            </div>
            <div class="duration">{formattedDuration}</div>
        </div>
    {:else}
        <div class="normal item"
            draggable="true"
            on:dragstart={handleDragStart}
            bind:this={root}>
            <img class="art"
                 src="{artworkUrl}"
                 alt="{attrs.artistName} - {attrs.albumName}"
                 draggable="false"
                 style="--size: {artSize}px">
            <div class="desc">
                <div class="name-line" style="--template-columns: {explicit ? "auto min-content 1fr" : "auto 1fr"}">
                    <div class="name" title="{attrs.name}">{attrs.name}</div>
                    {#if explicit}
                        <div class="explicit" title="Explicit song">E</div>
                    {/if}
                </div>
                <div class="artist-album" title="{attrs.artistName} - {attrs.albumName}">
                    {attrs.artistName} - {attrs.albumName}
                </div>
            </div>
            <div class="duration">{formattedDuration}</div>
        </div>
    {/if}
</div>

<style>
    .root {
        position: relative;
    }

    .item {
        display: grid;
        grid-gap: 10px;
        grid-template-rows: 1fr;
        padding: var(--song-item-padding, 10px);
        color: var(--song-item-fg-color, var(--song-fg-color, var(--app-fg-color)));
        background-color: var(--song-item-bg-color, transparent);
        border-radius: var(--song-item-border-radius, 5px);
        cursor: pointer;
    }

    .item:hover, .item:global(.context-menu-active) {
        color: var(--song-item-hover-fg-color, var(--app-bg-color));
        background-color: var(--song-item-hover-bg-color, var(--app-fg-color));
    }

    .item:hover .duration, .item:global(.context-menu-active) .duration {
        color: var(--song-item-hover-secondary-fg-color, var(--app-secondary-fg-color));
    }

    .art {
        grid-area: item-art;
        border-radius: 5px;
    }

    .track-number {
        grid-area: track-number;
        color: var(--app-secondary-fg-color);
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        color: var(--song-item-secondary-fg-color, var(--app-secondary-fg-color));
    }

    .item:hover .track-number, .item:global(.context-menu-active) .track-number {
        color: var(--song-item-hover-secondary-fg-color, var(--app-secondary-fg-color));
    }

    .desc {
        grid-area: desc;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: flex;
        align-items: flex-start;
        justify-content: space-evenly;
        flex-direction: column;
    }

    .name-line {
        grid-area: song-name;
        display: grid;
        grid-template-rows: 1fr;
        grid-template-columns: var(--template-columns);
        grid-gap: 5px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }

    .name,
    .artist-album {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

    .name-line,
    .artist-album {
        width: 100%;
    }

    .name {
        font-weight: bold;
    }

    .artist-album {
        font-size: 12px;
        color: var(--song-item-secondary-fg-color, var(--app-secondary-fg-color));
    }

    .item:hover .artist-album, .item:global(.context-menu-active) .artist-album {
        color: var(--song-item-hover-secondary-fg-color, var(--app-secondary-fg-color));
    }

    .explicit {
        font-size: 15px;
        font-weight: bold;
        color: var(--song-item-explicit-fg-color, var(--app-explicit-fg-color));
        background-color: var(--song-item-explicit-bg-color, var(--app-explicit-bg-color));
        border-radius: 2px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: left;
        padding: 0 5px;
        margin-left: 5px;
    }

    .duration {
        grid-area: duration;
        color: var(--song-item-secondary-fg-color, var(--app-secondary-fg-color));
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
    }

    .minimal.item {
        padding: var(--song-item-padding, 5px 10px);
        grid-template-columns: min-content 1fr min-content;
        grid-template-areas: "track-number desc duration";
    }

    .normal.item {
        grid-template-columns: min-content 1fr min-content;
        grid-template-areas: "item-art desc duration";
    }

    .normal .art {
        width: var(--size);
        height: var(--size);
    }
</style>
